import React, { CSSProperties, PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';

type TableRow = {
  modifier?: any;
  id?: string;
  className?: string;
  style?: CSSProperties;
};

export function TableRow({ children, modifier, className, id, style }: PropsWithChildren<TableRow>) {
  return (
    <tr id={id} className={className || bem('tables__row', modifier)} style={style}>
      {children}
    </tr>
  );
}
